<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-format-color-fill</v-icon>{{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <MaterialSupplyForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <template>
      <div class="materialsupplysub-list">
        <Toolbar
          :handle-add="() => addHandlerSub('MaterialSupplySub',item)"
        />
        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex sm12>
              <h1>{{$t('profile.material.subsupplies')}}</h1>
            </v-flex>
            <v-flex lg12>
              <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                <MaterialSupplySubFilterForm
                  ref="filterForm"
                  :values="filters"
                  slot="filter"
                />
              </DataFilter>

              <br />

              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="itemsSub"
      :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                :loading="isLoading"
                :loading-text="$t('global.loading')"
                :options.sync="options"
                :server-items-length="totalItems"
                class="elevation-1"
                item-key="@id"
                show-select
                @update:options="onUpdateOptions"
@click:row="editHandlerSubEvent"
              >
                    <template slot="item.input" slot-scope="{ item }">
                      {{ $n(item['input']) }}
                    </template>

                <ActionCell
                slot="item.action"
                slot-scope="props"
                :handle-edit="() => editHandlerSub(item,'MaterialSupplySub',props.item)"
                ></ActionCell>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import MaterialSupplyForm from '../../components/materialsupply/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import MaterialSupplySubFilterForm from '../../components/materialsupplysub/Filter';
import DataFilter from '../../components/DataFilter';

const servicePrefix = 'MaterialSupply';

export default {
  name: 'MaterialSupplyUpdate',
  servicePrefix,

  components: {
    Loading,
    Toolbar,
    MaterialSupplyForm,
    ActionCell,
    MaterialSupplySubFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.material.input'), value: 'input' },
        { text: this.$t('profile.material.medium'), value: 'medium.name' },
        { text: this.$t('profile.material.feedspec'), value: 'feedSpec.name' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'materialSupply' : this.$route.params.id,
      },
      selected: []
    };
  },
    mixins: [ListMixin,UpdateMixin],
  computed: {
    ...mapFields('materialsupply', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('materialsupply', ['find']),
    ...mapFields('materialsupplysub', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    ...mapGetters('materialsupplysub', {
          itemsSub: 'list'
    }),

  },

  methods: {
    ...mapActions('materialsupply', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    ...mapActions('materialsupplysub', {
      getPage: 'fetchAll',
    }),
    editHandlerSubEvent(value) {
      this.editHandlerSub(this.item,'MaterialSupplySub',value);
    }
  }
};
</script>
